import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { BehaviouralProgressTab } from '../BehaviouralProgressTab/BehaviouralProgressTab';
import { EntriesTab } from '../EntriesTab/EntriesTab';

const ContentAndEntriesTabBase = ({
  isLagoEnabled,
  calcCategoriesStatus,
  notificationsAlerts,
  editNotificationsAlerts,
}) => {
  return (
    <>
      <BehaviouralProgressTab />
      <EntriesTab
        isLagoEnabled={isLagoEnabled}
        calcCategoriesStatus={calcCategoriesStatus}
        editNotificationsAlerts={editNotificationsAlerts}
        notificationsAlerts={notificationsAlerts}
      />
    </>
  );
};

ContentAndEntriesTabBase.propTypes = exact({
  isLagoEnabled: PropTypes.bool,
  calcCategoriesStatus: PropTypes.func,
  notificationsAlerts: PropTypes.object,
  editNotificationsAlerts: PropTypes.func,
});

export const ContentAndEntriesTab = React.memo(ContentAndEntriesTabBase);
ContentAndEntriesTab.displayName = 'ContentAndEntriesTab';
